import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import loginReducer from "./Login/loginReducer";
import reletedPartiesListReducer from "./RelatedPartiesList/reletedPartiesListReducer";
import relatedPartyReducer from "./RelatedParty/ReletedPartyReducer";
import reletedPartiesDeleteReducer from "./RelatedPartiesDeleteList/reletedPartiesDeleteReducer";
import pendingApprovalList from "./PendingApprovalList/PendingApprovalListReducer";
import usersList from "./Users/usersReducer";
import userRolesList from "./UserRoles/userRolesReducer";
import dropdownList from "./DropdownData/dropdownDataReducer";
import roomList from "./RoomList/roomListReducer";
import procedureList from "./ProcedureList/procedureListReducer";
import appointmentList from "./AppointmentList/appointmentListReducer";
import inventoryList from "./InventoryList/inventoryListReducer";
import subcategoryList from "./SubCategoryList/subcategoryListReducer";
import auditList from "./InventoryAuditTrailList/inventoryAuditTrailReducer";
import inventorysummaryData from "./InventorySummary/inventorysummeryReducer";
import historyList from "./PaymentHistoryList/historyListReducer";
import transactionDetails from "./TransactionDetails/transactionDetailsReducer";
import invoiceDetails from "./InvoiceDetails/invoiceDetailsReducer";
import preInvoiceList from "./CreateInvoicePreData/CreateInvoicePreDataReducer";
import invoiceList from "./InvoiceList/invoiceListReducer";
import AdvFilterList from "./AppointmentAdvFilter/appoinmentAdvListReducer";
import receivePaymentDetails from "./ReceivePayment/receivePaymentDetailsReducer";
import practiceList from "./PracticeCompFetch/practicecompListReducer";
import auditTrailList from "./AuditTrail/AuditTrailReducer";
import activityList from "./ActivityList/ActivityListReducer";
import dashboardCounts from "./DashboardCountFetch/DashboardCountFetchReducer";
import appointmentReducer from "./AppointmentForm/AppointmentReducer";
import notesList from "./FetchNotes/FetchNotesReducer";
import initialNotesData from "./FetchInitialNotesData/FetchInitialNotesDataReducer";
import saveNotes from "./SaveNotes/SaveNotesReducer";
import deleteNotes from "./DeleteNotes/DeleteNotesReducer";
import statementsList from "./FetchStatements/FetchStatementsReducer";
import initialStatementsData from "./FetchInitialStatementsData/FetchInitialStatementsDataReducer";
import paymentDetailsData from "./PaymentShareViaEmail/PaymentShareViaEmailReducer";
import practitioner from "./ReceivePaymentAutoComplete/practitionerReducer";
import patient from "./AutoCompletePatient/patientReducer";
import supplier from "./AutoCompleteSupplier/AutoCompleteSupplierReducer";
import permissionData from "./FetchPermissions/FetchPermissionsReducer";
import product from "./AutoCompleteProduct/productReducer";
import practiceIncome from "./FetchPracticeIncome/FetchPracticeIncomeReducer";
import supplierIncome from "./FetchSuppliesIncome/FetchSuppliesIncomeReducer";
import customersTreatmentIncome from "./FetchCustomersTreatmentIncome/FetchCustomersTreatmentIncomeReducer";
import graphDataPracticeIncome from "./FetchGraphPracticeIncome/FetchGraphPracticeIncomeReducer";
import calendarAppointments from "./FetchCalendarAppointments/FetchCalendarAppointmentsReducer";
import deleteUser from "./DeleteUser/DeleteUserReducer"
import roomDropDownList from './FetchRoomList/FetchRoomListReducer';
import appointmentDetails from './FetchAppointmentDetails/FetchAppointmentDetailsReducer';
import initialTemplatesData from './FetchInitialTemplateData/FetchInitialTemplateDataReducer';
import templateContent from './FetchTemplateContent/FetchTemplateContentReducer';
import notifications from './FetchNotifications/FetchNotificationsReducer';
import readNotifications from './ReadNotification/ReadNotificationReducer';
import licenseStatus from './VerifyLicense/VerifyLicenseReducer';
import userDetails from './FetchUserdetails/FetchUserdetailsReducer';
import savedMedicalNotes from './SaveMedicalNotes/SaveMedicalNotesReducer';
import switchRoles from './SwitchRoles/SwitchRolesReducer';
import schemes from './FetchMedSchemes/FetchMedSchemesReducer';
import schemesPlan from './FetchMedSchemePlan/FetchMedSchemePlanReducer';
import schemesPlanOptions from './FetchMedSchemePlanOptions/FetchMedSchemePlanOptionsReducer';
import schemesPlanSubOptions from './FetchMedSchemePlanSubOptions/FetchMedSchemePlanSubOptionsReducer';
import disciplineList from './FetchDisciplineList/FetchDisciplineListReducer';
import destinationCodes from './UpdateDestinationCodes/UpdateDestinationCodesReducer';
import claimSubmitResponse from './SubmitClaim/SubmitClaimReducer';
import linkDestinationCodes from './LinkDestinationCode/LinkDestinationCodeReducer';
import mediclaimInvoiceList from './FetchMediclaimListing/FetchMediclaimListingReducer';
import mediclaimDetails from './FetchMediclaimDetails/FetchMediclaimDetailsReducer';
import diagnosisList from './FetchDiagnosisList/FetchDiagnosisListReducer';
import checkMSVDetails from './CheckMSV/CheckMSVReducer';
import invoiceData from './FetchInvoiceData/FetchInvoiceDataReducer';
import claimHistory from './FetchClaimHistory/FetchClaimHistoryReducer';
import proceduresList from './FetchProceduresList/FetchProceduresListReducer';
import procedureLookup from './FetchProcedureLookup/FetchProcedureLookupReducer';
import savePatient from './SavePatientProfile/SavePatientProfileReducer';
import modifierLookup from './FetchModifiersLookup/FetchModifiersLookupReducer';
import medicinesList from './FetchMedicinesList/FetchMedicinesListReducer';
import materialsList from './FetchMaterialsList/FetchMaterialsListReducer';
import planSubOptionLookup from './FetchPlanSubOptionLookup/FetchPlanSubOptionLookupReducer';
import pricegroupsList from './FetchPriceGroupList/FetchPriceGroupListReducer';
import externalPractitionerList from './FetchExternalPractitioner/FetchExternalPractitionerReducer';
import combinedPractitioners from './FetchCombinedPractitionerList/FetchCombinedPractitionerListReducer';
import externalPractitionersAutoComp from './FetchExternalPractitionerAutoComplete/FetchExternalPractitionerAutoCompleteReducer';
import allocatedInvoiceInvoiceListReducer from './FetchAllocatedPayments/FetchAllocatedPaymentsReducer';
import exceptionNotOnEraInvoiceListReducer from './FetchPaymentExceptionEra/FetchPaymentExceptionEraReducer';

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["DropdownList","permissionData"],
};

const rootReducer = combineReducers({
  allocatedInvoiceInvoiceList: allocatedInvoiceInvoiceListReducer,
  exceptionNoEraInvoiceList: exceptionNotOnEraInvoiceListReducer,
  userAuth: loginReducer,
  relatedPartiesList: reletedPartiesListReducer,
  relatedPartyData: relatedPartyReducer,
  deletedPartiesList: reletedPartiesDeleteReducer,
  pendingApprovalList: pendingApprovalList,
  usersList: usersList,
  userRolesList: userRolesList,
  dropdownList: dropdownList,
  roomList: roomList,
  procedureList: procedureList,
  appointmentList: appointmentList,
  inventoryList: inventoryList,
  subcategoryList: subcategoryList,
  auditList: auditList,
  inventorysummaryData: inventorysummaryData,
  historyList: historyList,
  transactionDetails: transactionDetails,
  invoiceDetails: invoiceDetails,
  preInvoiceList: preInvoiceList,
  invoiceList: invoiceList,
  AdvFilterList: AdvFilterList,
  receivePaymentDetails: receivePaymentDetails,
  practiceList: practiceList,
  auditTrailList: auditTrailList,
  activityList: activityList,
  dashboardCounts: dashboardCounts,
  appointmentDropdown: appointmentReducer,
  notesList: notesList,
  initialNotesData: initialNotesData,
  saveNotes: saveNotes,
  deleteNotes: deleteNotes,
  statementsList: statementsList,
  initialStatementsData: initialStatementsData,
  paymentDetailsData: paymentDetailsData,
  practitioner: practitioner,
  patient: patient,
  supplier: supplier,
  permissionData: permissionData,
  product: product,
  practiceIncome: practiceIncome,
  supplierIncome: supplierIncome,
  customersTreatmentIncome: customersTreatmentIncome,
  graphDataPracticeIncome: graphDataPracticeIncome,
  deleteUser:deleteUser,
  calendarAppointments: calendarAppointments,
  roomDropDownList: roomDropDownList,
  appointmentDetails: appointmentDetails,
  initialTemplatesData: initialTemplatesData,
  templateContent:templateContent,
  notifications: notifications,
  readNotifications: readNotifications,
  licenseStatus: licenseStatus,
  userDetails: userDetails,
  savedMedicalNotes: savedMedicalNotes,
  switchRoles: switchRoles,
  schemes: schemes,
  schemesPlan: schemesPlan,
  schemesPlanOptions: schemesPlanOptions,
  schemesPlanSubOptions: schemesPlanSubOptions,
  disciplineList: disciplineList,
  destinationCodes:destinationCodes,
  claimSubmitResponse: claimSubmitResponse,
  linkDestinationCodes: linkDestinationCodes,
  mediclaimInvoiceList:mediclaimInvoiceList,
  mediclaimDetails: mediclaimDetails,
  diagnosisList: diagnosisList,
  checkMSVDetails: checkMSVDetails,
  invoiceData: invoiceData,
  claimHistory: claimHistory,
  proceduresList: proceduresList,
  procedureLookup: procedureLookup,
  savePatient: savePatient,
  modifierLookup: modifierLookup,
  medicinesList: medicinesList,
  materialsList: materialsList,
  planSubOptionLookup: planSubOptionLookup,
  pricegroupsList: pricegroupsList,
  externalPractitionerList: externalPractitionerList,
  combinedPractitioners: combinedPractitioners,
  externalPractitionersAutoComp: externalPractitionersAutoComp
});

export default persistReducer(persistConfig, rootReducer);
